import { graphql } from "../generated";

// `progression` is @authenticated and only feeds the "resume where you left
// off" link plus My List's progress bar / "EP.x / y" line, so it is gated on
// $withProgression rather than fetched for every show of every section — see
// useSectionContent.
export const CatalogShowFragment = graphql(`
  fragment CatalogShowFragment on Show {
    id
    title
    displayTitle
    displayDescription
    displayTags
    views
    episodesCount
    publishedAt
    badgeType
    displayThumbnail {
      original
      medium
    }
    displayHorizontalThumbnail {
      original
    }
    displayImage {
      original
    }
    displayTitleImage {
      original
    }
    progression @include(if: $withProgression) {
      progress
      total
      nextEpisode {
        id
        number
      }
    }
    isBookmarked @include(if: $withBookmarkState)
  }
`);
